import { Link } from "react-router-dom";
import {
  Nav,
  NavItem,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  NavLink,
  UncontrolledTooltip,
} from "reactstrap";
import { useState } from "react";

import { LAYOUT_MODES, TABS } from "../../constants/index";
import LightDarkMode from "../../components/LightDarkMode";

import { MENU_ITEMS, MenuItemType } from "./menu";
import { useLayout } from "../../context/LayoutContext";
import { useProfileImage } from "../../context/ProfileImageContext";

//
// Logos
//
const LogoLightSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24">
    <path d="M8.5,18l3.5,4l3.5-4H19c1.103,0,2-0.897,2-2V4c0-1.103-0.897-2-2-2H5C3.897,2,3,2.897,3,4v12c0,1.103,0.897,2,2,2H8.5z M7,7h10v2H7V7z M7,11h7v2H7V11z" />
  </svg>
);

const LogoDarkSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24">
    <path d="M8.5,18l3.5,4l3.5-4H19c1.103,0,2-0.897,2-2V4c0-1.103-0.897-2-2-2H5C3.897,2,3,2.897,3,4v12c0,1.103,0.897,2,2,2H8.5z M7,7h10v2H7V7z M7,11h7v2H7V11z" />
  </svg>
);

const Logo = () => (
  <div className="navbar-brand-box">
    <Link to="#" className="logo logo-dark">
      <span className="logo-sm">
        <LogoLightSVG />
      </span>
    </Link>

    <Link to="#" className="logo logo-light">
      <span className="logo-sm">
        <LogoDarkSVG />
      </span>
    </Link>
  </div>
);

//
// MENU ITEM COMPONENT
//
const MenuNavItem = ({ item }: { item: MenuItemType }) => {
  const { activeTab, toggleTab } = useLayout();

  return (
    <>
      <NavItem className={item.className} id={`${item.key}-container`}>
        <NavLink
          href="#"
          active={activeTab === item.tabId}
          id={item.key}
          role="tab"
          onClick={() => toggleTab(item.tabId)}
        >
          <i className={item.icon}></i>
        </NavLink>
      </NavItem>

      <UncontrolledTooltip
        target={`${item.key}-container`}
        placement="right"
        transition={{ timeout: 1 }}
        delay={0}
      >
        {item.tooltipTitle}
      </UncontrolledTooltip>
    </>
  );
};

//
// PROFILE DROPDOWN
//
const ProfileDropdownMenu = () => {
  const { avatarImage } = useProfileImage();

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { toggleTab } = useLayout();

  return (
    <Dropdown
      nav
      isOpen={dropdownOpen}
      className="profile-user-dropdown"
      toggle={() => setDropdownOpen(!dropdownOpen)}
    >
      <DropdownToggle nav className="bg-transparent">
        <img src={avatarImage} alt="avatar" className="profile-user rounded-circle" />
        {/* <img src={avatar1} alt="" className="profile-user rounded-circle" /> */}
      </DropdownToggle>

      <DropdownMenu>
        <DropdownItem
          className="d-flex align-items-center justify-content-between"
          onClick={() => toggleTab(TABS.USERS)}
        >
          Perfil <i className="bx bx-user-circle text-muted ms-1"></i>
        </DropdownItem>

        <DropdownItem
          className="d-flex align-items-center justify-content-between"
          onClick={() => toggleTab(TABS.SETTINGS)}
        >
          Configuração <i className="bx bx-cog text-muted ms-1"></i>
        </DropdownItem>

        <DropdownItem
          className="d-flex align-items-center justify-content-between"
          href="/auth-changepassword"
        >
          Trocar sua senha <i className="bx bx-lock-open text-muted ms-1"></i>
        </DropdownItem>

        <DropdownItem divider />

        <DropdownItem
          className="d-flex align-items-center justify-content-between"
          tag="a"
          href="/logout"
        >
          Sair <i className="bx bx-log-out-circle text-muted ms-1"></i>
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

//
// MAIN COMPONENT
//
const SideMenu = ({ onChangeLayoutMode }: any) => {
  return (
    <div className="side-menu flex-lg-column">

      <Logo />

      <div className="flex-lg-column my-0 sidemenu-navigation">
        <Nav pills className="side-menu-nav" role="tablist">

          {MENU_ITEMS.map((item, key) => (
            <MenuNavItem item={item} key={key} />
          ))}

          <LightDarkMode layoutMode={LAYOUT_MODES["DARK"]}
            onChangeLayoutMode={onChangeLayoutMode} />

          <ProfileDropdownMenu />
        </Nav>
      </div>
    </div>
  );
};

export default SideMenu;
